<!-- Answers: completed previous month vs month before vs same month last year (full months only). -->
<template>
    <dashboard-panel title="Previous month comparisons" :subtitle="subtitle">
        <dashboard-change-badge :change="yearChange" :label="sameMonthLastYearLabel" />
        <dashboard-bar-chart-host
            wrap-class="compact"
            :labels="labels"
            :datasets="datasets"
            :extra-options="chartOptions"
        />
    </dashboard-panel>
</template>

<script setup>
import { computed } from "vue";
import { computeChange } from "../../helpers/dashboardAggregations";
import DashboardBarChartHost from "./DashboardBarChartHost.vue";
import DashboardChangeBadge from "./DashboardChangeBadge.vue";
import DashboardPanel from "./DashboardPanel.vue";

const props = defineProps({
    labels: { type: Array, default: () => [] },
    datasets: { type: Array, default: () => [] },
});

// Year-over-year: completed previous month (data[0]) vs the same month last year (data[2]).
const sameMonthLastYearLabel = computed(() => props.labels?.[2] || "the same month last year");
const yearChange = computed(() => {
    const values = props.datasets?.[0]?.data || [];
    if (values.length < 3) {
        return null;
    }
    return computeChange(values[0], values[2]);
});

// Subtitle from labels + first dataset so totals always match the chart.
const subtitle = computed(() => {
    const values = props.datasets?.[0]?.data || [];
    if (!props.labels?.length) {
        return "";
    }
    return props.labels
        .map((label, index) => `${label}: ${Number(values[index]) || 0}`)
        .join(" · ");
});

const chartOptions = { plugins: { legend: { display: false } } };
</script>
